/**
 * Validate if product is ready for rental equipment step
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct(to);
    const { firstStepRoute } = useFlow(to);

    if (product.value.config.type === 'Activity' && product.value.config.isRental) {
        const productActivity = product.value as ProductActivity;
        if (!productActivity.dateFrom || !productActivity.dateUntil) {
            return navigateTo(firstStepRoute.value);
        }
        if (!productActivity.pickupLocation) {
            return navigateTo(firstStepRoute.value);
        }
    }
    else {
        return abortNavigation();
    }
});
